import { axios } from '../../../services/axios';
import * as CONST from '../../constants';

const onSuccess = (dispatch, data) => {
  dispatch({ type: CONST.STATUS_CREATE_SUCCESS, status: data.status });
};

const onFailed = (dispatch, error) => {
  dispatch({ type: CONST.STATUS_CREATE_ERROR, error });
};

const handleResponse = (dispatch, response) => {
  if (response.status === 200) {
    onSuccess(dispatch, response.data);
  } else {
    onFailed(dispatch, response.data);
  }
};

export const statusCreate = (data) => {
  return async (dispatch) => {
    dispatch({ type: CONST.STATUS_CREATE_REQUEST });

    axios.post('/statuses', data).then((response) => {
      handleResponse(dispatch, response);
    });
  };
};
